import { apiDadataService } from '../APIService';

export default {
  /**
   *  {
   *    query: string;
   *    count: number;
   *  };
   */
  suggestAddress(payload) {
    return apiDadataService.post('/suggest/address', payload);
  },

  /**
   *  {
   *    query: string;
   *  };
   */
  getDataByINN(payload) {
    return apiDadataService.post('/findById/party', payload);
  },
};
